import { db } from '../firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

const storageKey = (uid) => `favoriteCafeIds:${uid}`;

const readLocal = (uid) => {
  if (!uid) return [];
  try {
    const raw = localStorage.getItem(storageKey(uid));
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.filter(Boolean) : [];
  } catch {
    return [];
  }
};

const writeLocal = (uid, ids) => {
  if (!uid) return;
  localStorage.setItem(storageKey(uid), JSON.stringify(Array.from(new Set((ids || []).filter(Boolean)))));
};

const isPermissionError = (e) =>
  String(e?.message || '').toLowerCase().includes('missing or insufficient permissions');

export async function getFavoriteCafeIds(uid) {
  const localIds = readLocal(uid);
  if (!uid) return localIds;
  try {
    const snap = await getDoc(doc(db, 'users', uid));
    const ids = Array.isArray(snap.data()?.favoriteCafeIds) ? snap.data().favoriteCafeIds : [];
    writeLocal(uid, ids);
    return ids;
  } catch (e) {
    if (isPermissionError(e)) return localIds;
    throw e;
  }
}

export async function saveFavoriteCafeIds(uid, ids, email = '') {
  const normalized = Array.from(new Set((ids || []).filter(Boolean)));
  writeLocal(uid, normalized);
  if (!uid) return { source: 'local' };

  try {
    const ref = doc(db, 'users', uid);
    const snap = await getDoc(ref);
    if (!snap.exists()) {
      await setDoc(
        ref,
        {
          uid,
          email,
          favoriteCafeIds: normalized,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );
    } else {
      await setDoc(
        ref,
        {
          favoriteCafeIds: normalized,
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );
    }
    return { source: 'remote' };
  } catch (e) {
    if (isPermissionError(e)) return { source: 'local' };
    throw e;
  }
}

export async function toggleFavoriteCafe(uid, cafeId, email = '') {
  const ids = await getFavoriteCafeIds(uid);
  const has = ids.includes(cafeId);
  const next = has ? ids.filter((id) => id !== cafeId) : [...ids, cafeId];
  const result = await saveFavoriteCafeIds(uid, next, email);
  return { isFavorite: !has, ids: next, source: result.source };
}

